import React, { useState } from 'react';
import { Modal, Row, Col, Button } from 'antd';
import ManagePagesListItem from './ManagePagesListItem';
import { PlusOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
const ManagePagesModal = ({
  handleOk,
  handleCancel,
  pages,
  enabledSkills,
  setPages,
  errors,
}) => {
  const handleDelete = (pageId) => {
    const findPage = pages.find((page) => page._id === pageId);
    let updatedPages = [];
    if (findPage.isNew) {
      updatedPages = pages.filter((page) => page._id !== pageId);
    } else {
      findPage.disabled = true;
      updatedPages = pages.map((page) => {
        if (page._id === findPage._id) {
          return findPage;
        }
        return page;
      });
    }

    setPages(updatedPages);
  };
  const handleNameChange = (event, pageId) => {
    const newPages = [...pages];
    const pageIndex = newPages.findIndex((page) => page._id === pageId);
    const page = newPages[pageIndex];
    page.name = event.target.value;
    newPages[pageIndex] = page;
    setPages(newPages);
  };
  const handleProductChange = (value, pageId) => {
    const newPages = [...pages];
    const pageIndex = newPages.findIndex((page) => page._id === pageId);
    const page = newPages[pageIndex];
    page.pageViewType = value;
    newPages[pageIndex] = page;
    setPages(newPages);
  };
  const addNewRowToPages = () => {
    const newPages = [...pages];
    newPages.push({
      name: '',
      pageViewType: '',
      disabled: false,
      isNew: true,
      _id: 'id' + new Date().getTime(),
    });
    setPages(newPages);
  };
  return (
    <Modal
      okText='Save'
      width={600}
      style={{ left: '10%', top: '12%' }}
      bodyStyle={{ height: '502px', overflowY: 'auto' }}
      title='Manage pages'
      visible={true}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Row>
        <Col span={8}>Name</Col>
        <Col span={8}>Page Type</Col>
        <Col span={8}></Col>
      </Row>
      {pages
        .filter((item) => !item.disabled)
        .map((item, index) => (
          <ManagePagesListItem
            disableDelete={
              pages.filter((page) => !page.disabled).length === 1 ? true : false
            }
            handleDelete={handleDelete}
            handleNameChange={handleNameChange}
            handleProductChange={handleProductChange}
            index={index}
            key={index}
            page={{ ...item }}
            enabledSkills={enabledSkills}
            error={errors[item._id]}
          />
        ))}

      <Button
        disabled={pages && !pages[pages.length - 1].name}
        style={{ marginTop: '20px' }}
        type='primary'
        onClick={() => addNewRowToPages()}
      >
        <PlusOutlined /> Add Page
      </Button>
    </Modal>
  );
};

export default withRouter(ManagePagesModal);
